module.exports = __webpack_public_path__ + "c87313aa86b7caa31a9a0accaa584970.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-Medium.ttf
// module id = 1272
// module chunks = 0